import { PreloaderService } from './../_services/Preloader.service';
import { LogService } from '../_services/_LogServices/Log.service';
import { Component, OnInit } from '@angular/core';
import { LogView } from '../_models/LogView';
import { ToasterService } from '../_services/Toaster.service';
import { Subscription, interval } from 'rxjs';


@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-RealTIme_LogView',
  templateUrl: './RealTIme_LogView.component.html',
  styleUrls: ['./RealTIme_LogView.component.css'],
})
// tslint:disable-next-line: class-name
export class RealTIme_LogViewComponent implements OnInit {
  public tableWidget: any;
DateTime:any;
  Logs: LogView[];
  private updateSubscription: Subscription;

  constructor(
    private LogServices: LogService,
    private noti: ToasterService,
    private preloader: PreloaderService
    ) { }


  ngOnInit() {
    var today = new Date();
    var date = (today.getMonth()+1)+'/'+today.getDate()+'/'+ today.getFullYear()+' '+today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    this.DateTime=date;
    this.updateSubscription = interval(1000).subscribe(
      (val) => {
        this.LoadLogs(this.DateTime);
      }
    );

  }
  ngAfterViewInit() {
    this.preloader.hide();
  }
  LoadLogs(DateTime:any) {
    this.LogServices.GetOverAllDeviceStatus(DateTime).subscribe(
      Response => {
        if(Response.status==200)
        {
        this.Logs = Response.body;

        }

      },
      (error) => {

      }
    );
  }


}
